var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"hero"}),_c('div',{staticClass:"items"},[_c('router-link',{staticClass:"nav-item",attrs:{"to":"/ga"}},[_vm._v("相册")]),_c('router-link',{staticClass:"nav-item",attrs:{"to":"/resume"}},[_vm._v("简历")]),_c('router-link',{staticClass:"nav-item",attrs:{"to":"/blog"}},[_vm._v("博客")]),_c('router-link',{staticClass:"nav-item",attrs:{"to":"/note"}},[_vm._v("笔记")])],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ee5cdc12","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = null
// module chunks = 